export class NotAuthenticatedError extends Error {
    cause: Error | null;
    expiration_ms: number | null;
    constructor(cause: Error | null, expiration_ms: number | null, status: number | undefined, url: string | undefined, request_url: string | undefined) {
        super(`Not authenticated ${status} ${expiration_ms} for ${request_url} from ${url}`, { cause });
        this.name = 'NotAuthenticatedError';
        this.cause = cause;
        this.expiration_ms = expiration_ms;
    }
}

// Investigate potential bug — frontend expiration data appears valid while auth fails.
export class UnexpectedAuthenticateError extends Error {
    cause: Error | null;
    expiration_ms: number | null;
    constructor(cause: Error | null, expiration_ms: number | null, status: number | undefined, url: string | undefined, request_url: string | undefined) {
        super(`Unexpected authentication failure ${status} ${expiration_ms} for ${request_url} from ${url}`, { cause });
        this.name = 'UnexpectedAuthenticateError';
        this.cause = cause;
        this.expiration_ms = expiration_ms;
    }
}

export class IgnoreCanceledError extends Error {
    constructor(cause: Error | null) {
        super(`Ignore canceled error${cause?.message ? `: ${cause.message}` : ''}`, { cause });
        this.name = 'IgnoreCanceledError';
        this.cause = cause;
    }
}
